// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"b91460c8","682":"3fee748f","687":"01cf0840","836":"06cfb5ac","903":"d854b58a","924":"f17526c1","992":"92132d4f"}[chunkId] + ".chunk.css";
};